import React, { Suspense, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import PageLoding from "../components/PageLoding";
import MainLayout from "../Layout/MainLayout";

// const Home = React.lazy(() => import("../view/home/index"));
const Home = React.lazy(() => import("../view/home/homeNew"));
const NewAgent = React.lazy(() => import("../view/newAgent/indexNew"));
const DetailAgent = React.lazy(() => import("../view/detailAgent/indexNew"));

const Profile = React.lazy(() => import("../view/profile/indexNew"));
const Refresh = React.lazy(() => import("../view/refresh/index"));
const Summary = React.lazy(() => import("../view/summary/index"));
const PrivyNativeAppLogin = React.lazy(() =>
  import("../view/nativeAppPrivyLogin/PrivyNativeAppLogin")
);
const PrivyNativeAppLogout = React.lazy(() =>
  import("../view/nativeAppPrivyLogin/PrivyNativeAppLogout")
);
const PersonalAi = React.lazy(() => import("../view/personal/index"));

export default function Router() {
  return (
    <Suspense fallback={<></>}>
      <Routes>
        <Route path="/native-login" element={<PrivyNativeAppLogin />} />
        <Route path="/native-logout" element={<PrivyNativeAppLogout />} />
        <Route path="/*" element={<MainLayout />}>
          <Route path="" element={<Home />} />
          <Route path="home" element={<Home />} />
          <Route path="create" element={<NewAgent />} />
          <Route path="agent/:id" element={<DetailAgent />} />
          <Route path="profile/:id?" element={<Profile />} />
          <Route path="personalai/:persona_id?" element={<PersonalAi />} />
          <Route path="refresh" element={<Refresh />} />
          <Route path="summary" element={<Summary />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
